/**
 * 
 * @description triggers probe api for fetching and mapping data ( if available )
 */

import { getProbeDetails } from "../../../services/httpCalls"

export const getPanDetails= async ({
    pan,
    disablePan,
    setDisablePan,
    setPan,
    form,
    setShowLoader,
    Cookies,
    dayjs, 
    setIsGstNotThere,
    notify
}) => {
    if (disablePan) {
      setDisablePan(false)
      form.resetFields()
      localStorage.setItem("allowCkyc", "false")
      setPan("")
    } else {
      if (pan.length === 10) {
        Cookies.set("pan", pan)
        setShowLoader(true)
        await getProbeDetails(pan)
          .then(res => {
            form.setFieldsValue({
              //business details
              legalName: res?.legalName,
              gstNumber: res?.gstNumber,
              cin: res.cin,
              leiNumber: res.leiNumber,
              dateOfIncorporation: dayjs(res.dateOfIncorporation),
              countryOfIncorporation: res.countryOfIncorporation,
              annualTurnOver: res.annualTurnOver,
              netWorth: res.netWorth,
              listedCompany: res.listedCompany === "Yes" ? true : false,
              tan: res.tan,
              website: res.website,
              productDescription: res.description,
              comapnyEmail: res.email,
              //registered address detail
              registeredAddress_addressLineOne:
                res.registeredAddress.addressLineOne,
              registeredAddress_addressLineTwo:
                res.registeredAddress.addressLineTwo,
              registeredAddress_city: res.registeredAddress.city,
              registeredAddress_country: res.registeredAddress.country === null ? "IN" : res.registeredAddress.country,
              registeredAddress_pinCode: res.registeredAddress.pinCode,
              registeredAddress_state: res.registeredAddress.state,
              //business address detail
              bussinessAddress_addressLineOne:
                res.businessAddress.addressLineOne,
              bussinessAddress_addressLineTwo:
                res.businessAddress.addressLineTwo,
              bussinessAddress_city: res.businessAddress.city,
              bussinessAddress_country: res.businessAddress.country === null ? "IN" : res.businessAddress.country,
              bussinessAddress_pinCode: res.businessAddress.pinCode,
              bussinessAddress_state: res.businessAddress.state
            })
            if(res?.gstNumber){
              setIsGstNotThere(false)
            }
            setDisablePan(true)
          })
          .catch(err => {
            notify.error("Error fetching details or details not found ")
          })
          .finally(() => {
            setShowLoader(false)
          })
      } else {
        notify.error("Please enter a valid PAN!")
      }
    }
  }
